import Player from "./slideup.comp";

export default Player